
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30849',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30849",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55411",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8396",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11851",
  "I18n": "static-7.1681",
  "quartz": "static-1.7526",
  "quartz-config": "static-1.1304",
  "quartz-core": "static-1.6745",
  "react-dlb": "static-1.90",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.81",
  "reselect": "static-3.13",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.983",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55398",
  "feedback-utils": "static-1.55402",
  "forms-embed-utils-lib": "static-1.4826",
  "forms-utils-lib": "static-1.13167",
  "foundations-assets": "static-1.5246",
  "foundations-components": "static-1.8574",
  "foundations-theming": "static-1.4838",
  "hub-http": "static-1.6572",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12158",
  "icons": "static-2.695",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4159",
  "raven": "static-3.5925",
  "react": "static-7.199",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17085",
  "react-select-plus": "static-1.114",
  "react-utils": "static-2.5593",
  "react-virtualized": "static-2.108",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.509",
  "tinymce-plugins": "static-1.58317",
  "transmute": "static-2.97",
  "ui-images": "static-2.1265",
  "UIComponents": "static-3.8797",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3803",
  "quartz-webpack": "static-1.3750",
  "foundations-theming-specialty": "static-1.2554",
  "property-description-translator": "static-1.4185",
  "HeadJS": "static-2.805",
  "framer-motion": "static-1.80",
  "hs-test-utils-bend-plugin": "static-1.3507",
  "msw": "static-1.39",
  "testing-library": "static-1.159",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.92",
  "jasmine": "static-4.4672",
  "jasmine-runner": "static-1.6809",
  "opentelemetry-fe-types": "static-1.139",
  "dispatcher": "static-1.144",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.889",
  "hubspotter-http": "static-1.4895",
  "mobile-manifest-mixins": "static-1.585",
  "module-federation": "static-1.34",
  "opentelemetry-fe": "static-1.514",
  "quartz-auth": "static-1.1201",
  "quartz-head": "static-1.1191",
  "quartz-i18n": "static-1.1201",
  "quartz-routing": "static-1.956",
  "quartz-test": "static-1.1201",
  "quartz-tracking": "static-1.905",
  "trellis-components": "static-1.2805",
  "ui-fonts": "static-1.1113",
  "usage-tracker-container": "static-1.7663",
  "usage-tracker-core": "static-1.7523",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.250",
  "conversations-skeleton-state": "static-1.7596",
  "reference-resolvers": "static-1.8542",
  "sanitize-text": "static-1.8518",
  "PatternValidationJS": "static-1.3251",
  "ReduxMessenger": "static-2.10732",
  "outpost": "static-1.4500",
  "rpc-client-utils": "static-1.5025",
  "sanitize": "static-1.4831",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4843",
  "floating-ui": "static-1.64",
  "hs-story-utils": "static-1.9785",
  "react-aria": "static-1.73",
  "react-create-root-preference": "static-1.80",
  "tanstack-table": "static-1.62",
  "trellis-assets": "static-1.2786",
  "bend-plugin-foundations-theming": "static-1.3321",
  "foundations-theming-base": "static-1.3823",
  "stylex": "static-1.42",
  "hs-locale-management": "static-1.331",
  "csstype": "static-1.50",
  "web-vitals": "static-1.16",
  "ai-components-ui-library": "static-1.9830",
  "atom": "static-1.5441",
  "codemirror": "static-5.103",
  "content-assistance-lib": "static-1.8274",
  "ContentUtils": "static-1.69234",
  "data-token-picker": "static-1.16965",
  "file-manager-components": "static-1.24615",
  "FileManagerCore": "static-1.40114",
  "FileManagerLib": "static-1.40255",
  "frontend-preferences-client": "static-1.8281",
  "hub-http-contrib": "static-1.3388",
  "interframe": "static-3.5103",
  "layout-dnd-components": "static-1.13048",
  "layout-dnd-utils": "static-1.12023",
  "property-translator": "static-1.5742",
  "react-codemirror": "static-1.11003",
  "react-colorpicker": "static-2.10575",
  "reference-resolvers-lite": "static-1.8463",
  "rich-text-lib": "static-1.20389",
  "tinymce-data": "static-1.41288",
  "tinymce-themes": "static-1.57173",
  "ui-addon-emoji-picker": "static-1.10231",
  "ui-addon-sales-email": "static-1.5563",
  "ui-brand-identity-lib": "static-1.16671",
  "bender-build-tools": "static-1.3452",
  "opentelemetry-web": "static-1.15",
  "beacon-keepalive-queue": "static-1.65",
  "hub-http-shared-msw-handlers": "static-1.10710",
  "hubspotter-http-shared-msw-handlers": "static-1.10708",
  "usage-tracker-session-replay": "static-1.5359",
  "base-ui": "static-1.23",
  "react-day-picker": "static-1.11",
  "trellis-theming": "static-1.1334",
  "tanstack-virtual": "static-1.39",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.435",
  "chirp-fetch": "static-1.2257",
  "stylex-utils": "static-1.149",
  "chatspot-core": "static-1.23290",
  "copilot-toolkit": "static-1.11942",
  "customer-data-objects-ui-components": "static-1.13391",
  "data-fetching-client": "static-1.10010",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5120",
  "ui-addon-video-player": "static-1.9052",
  "ui-coaching-tips": "static-1.29408",
  "usage-tracker": "static-1.7673",
  "cms-field-types": "static-1.5171",
  "content-icons-ui": "static-1.2410",
  "integrations-lib": "static-1.17180",
  "customer-data-objects": "static-1.8048",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.1880",
  "apollo-link-hub-http": "static-2.5007",
  "apollo-stack-hubspot": "static-3.95",
  "graphql": "static-1.90",
  "immer": "static-1.102",
  "immerable": "static-1.4505",
  "ui-addon-iframeable": "static-1.9438",
  "video-components-external": "static-1.12242",
  "video-data-lib": "static-1.35900",
  "breeze-artifacts-sdk": "static-1.533",
  "audio-components": "static-1.6421",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29889",
  "FileManagerImages": "static-1.37766",
  "foundations-components-legacy": "static-1.1599",
  "html-to-image": "static-1.62",
  "redux-toolkit": "static-1.79",
  "salesImages": "static-1.622",
  "ui-universal-auth": "static-1.9502",
  "urlinator": "static-1.4877",
  "video-components": "static-1.14244",
  "video-embed": "static-1.36734",
  "ts-schema": "static-1.4330",
  "ContentData": "static-1.69309",
  "layout-data-lib": "static-1.10348",
  "react-dnd-compat": "static-1.4975",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1905",
  "external-options-client-types": "static-1.4377",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7254",
  "hs-promise-utils": "static-1.5950",
  "inbound-db-properties-service-client": "static-1.4083",
  "NamespacedHubStyle": "static-2.9295",
  "growth-onboarding-confetti": "static-1.3425",
  "SharedI18nStrings": "static-1.184",
  "ui-addon-i18n": "static-1.11508",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5799",
  "magpie-types": "static-1.5259",
  "simple-logging-lib": "static-1.3410",
  "avatar-components": "static-1.2844",
  "customer-data-ui-utilities": "static-1.10191",
  "growth-onboarding-feedback-components": "static-1.6946",
  "flux-actions": "static-1.375",
  "hubspot-apollo-client": "static-1.5235",
  "integrations-error-boundary-lib": "static-1.14595",
  "integrations-tracking-lib": "static-1.5971",
  "laboratory-lib": "static-3.7513",
  "native-integrations-shared-strings": "static-1.8126",
  "redux-observable": "static-1.76",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10632",
  "unified-auth": "static-1.1016",
  "breeze-engine-chat-components": "static-1.858",
  "breeze-engine-core": "static-1.1158",
  "ably": "static-2.2",
  "highlight.js": "static-1.87",
  "pulse": "static-1.991",
  "navigation-messaging": "static-1.8259",
  "content-media-composition-data-lib": "static-1.13358",
  "content-media-compositions": "static-2.17365",
  "idb-keyval": "static-1.52",
  "media-bridge-lib": "static-1.19481",
  "nudge-client-utils": "static-1.3229",
  "unified-auth-core-lib": "static-1.1298",
  "social-insights-client-types": "static-1.22728",
  "advanced-menus-core": "static-1.15650",
  "advanced-menus-lib": "static-1.12507",
  "ExportDialog": "static-6.10740",
  "ui-memberships-settings-lib": "static-1.34941",
  "conditional-properties-service-client": "static-1.4053",
  "crm-pipelines-api-client-types": "static-1.4384",
  "fdsr-migration-layer": "static-1.373",
  "framework-builder-read-service-client": "static-1.4258",
  "framework-data-schema-quick-fetch": "static-1.7159",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3944",
  "persist-promise": "static-1.4062",
  "foundations-components-test-utils": "static-1.6057",
  "reactive-lib": "static-1.1079",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.694",
  "universal-page-editor-lib": "static-1.3369",
  "adobe-sign-auth-lib": "static-1.568",
  "ads-unified-auth-lib": "static-1.1567",
  "custom-vendor-connection-lib": "static-1.66",
  "google-sheets-integration-lib": "static-1.1130",
  "microsoft-drive-auth-lib": "static-1.266",
  "surveymonkey-integration-lib": "static-1.606",
  "slack-ui-library": "static-1.10758",
  "bend-plugin-pulse": "static-1.494",
  "event-emitter": "static-1.1318",
  "fast-json-patch": "static-1.71",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.2986",
  "nudge-renderer-utils": "static-1.3305",
  "onboarding-tours": "static-1.17215",
  "whisper-core-api": "static-1.7427",
  "fsm": "static-1.4114",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15649",
  "simple-menus-lib": "static-1.17166",
  "settings-ui-lib": "static-1.12883",
  "crm-record-cards-service-types": "static-1.3803",
  "location-customization-utils-lib": "static-1.10211",
  "getting-started-shared-tasks": "static-1.19350",
  "growth-data-modal": "static-1.5971",
  "growth-onboarding-next-action-utils": "static-1.2788",
  "navigation-components": "static-1.18932",
  "onboarding-tours-client": "static-1.5430",
  "onboarding-tours-utils": "static-1.1282",
  "ui-shepherd-tracker": "static-1.8013",
  "user-context": "static-1.5471",
  "react-flip-move": "static-1.79",
  "onboarding-data-sync-lib": "static-1.2613",
  "growth-onboarding-next-action-components": "static-1.2816",
  "user-context-client": "static-1.4869",
  "nest": "static-1.596",
  "getting-started-shared-tasks-store": "static-1.18468",
  "InboxConnectUtils": "static-4.15653",
  "meetings-connect-utils-lib": "static-1.7971",
  "onboarding-scopes": "static-1.6813"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30849",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55411",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8396",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11851",
  "I18n": "/I18n/static-7.1681",
  "quartz": "/quartz/static-1.7526",
  "quartz-config": "/quartz-config/static-1.1304",
  "quartz-core": "/quartz-core/static-1.6745",
  "react-dlb": "/react-dlb/static-1.90",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.81",
  "reselect": "/reselect/static-3.13",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.983",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55398",
  "feedback-utils": "/feedback-utils/static-1.55402",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4826",
  "forms-utils-lib": "/forms-utils-lib/static-1.13167",
  "foundations-assets": "/foundations-assets/static-1.5246",
  "foundations-components": "/foundations-components/static-1.8574",
  "foundations-theming": "/foundations-theming/static-1.4838",
  "hub-http": "/hub-http/static-1.6572",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12158",
  "icons": "/icons/static-2.695",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4159",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.199",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17085",
  "react-select-plus": "/react-select-plus/static-1.114",
  "react-utils": "/react-utils/static-2.5593",
  "react-virtualized": "/react-virtualized/static-2.108",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.509",
  "tinymce-plugins": "/tinymce-plugins/static-1.58317",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1265",
  "UIComponents": "/UIComponents/static-3.8797",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3803",
  "quartz-webpack": "/quartz-webpack/static-1.3750",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2554",
  "property-description-translator": "/property-description-translator/static-1.4185",
  "HeadJS": "/HeadJS/static-2.805",
  "framer-motion": "/framer-motion/static-1.80",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3507",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.159",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.92",
  "jasmine": "/jasmine/static-4.4672",
  "jasmine-runner": "/jasmine-runner/static-1.6809",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.139",
  "dispatcher": "/dispatcher/static-1.144",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.889",
  "hubspotter-http": "/hubspotter-http/static-1.4895",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.585",
  "module-federation": "/module-federation/static-1.34",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.514",
  "quartz-auth": "/quartz-auth/static-1.1201",
  "quartz-head": "/quartz-head/static-1.1191",
  "quartz-i18n": "/quartz-i18n/static-1.1201",
  "quartz-routing": "/quartz-routing/static-1.956",
  "quartz-test": "/quartz-test/static-1.1201",
  "quartz-tracking": "/quartz-tracking/static-1.905",
  "trellis-components": "/trellis-components/static-1.2805",
  "ui-fonts": "/ui-fonts/static-1.1113",
  "usage-tracker-container": "/usage-tracker-container/static-1.7663",
  "usage-tracker-core": "/usage-tracker-core/static-1.7523",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.250",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7596",
  "reference-resolvers": "/reference-resolvers/static-1.8542",
  "sanitize-text": "/sanitize-text/static-1.8518",
  "PatternValidationJS": "/PatternValidationJS/static-1.3251",
  "ReduxMessenger": "/ReduxMessenger/static-2.10732",
  "outpost": "/outpost/static-1.4500",
  "rpc-client-utils": "/rpc-client-utils/static-1.5025",
  "sanitize": "/sanitize/static-1.4831",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4843",
  "floating-ui": "/floating-ui/static-1.64",
  "hs-story-utils": "/hs-story-utils/static-1.9785",
  "react-aria": "/react-aria/static-1.73",
  "react-create-root-preference": "/react-create-root-preference/static-1.80",
  "tanstack-table": "/tanstack-table/static-1.62",
  "trellis-assets": "/trellis-assets/static-1.2786",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3321",
  "foundations-theming-base": "/foundations-theming-base/static-1.3823",
  "stylex": "/stylex/static-1.42",
  "hs-locale-management": "/hs-locale-management/static-1.331",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.16",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9830",
  "atom": "/atom/static-1.5441",
  "codemirror": "/codemirror/static-5.103",
  "content-assistance-lib": "/content-assistance-lib/static-1.8274",
  "ContentUtils": "/ContentUtils/static-1.69234",
  "data-token-picker": "/data-token-picker/static-1.16965",
  "file-manager-components": "/file-manager-components/static-1.24615",
  "FileManagerCore": "/FileManagerCore/static-1.40114",
  "FileManagerLib": "/FileManagerLib/static-1.40255",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8281",
  "hub-http-contrib": "/hub-http-contrib/static-1.3388",
  "interframe": "/interframe/static-3.5103",
  "layout-dnd-components": "/layout-dnd-components/static-1.13048",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12023",
  "property-translator": "/property-translator/static-1.5742",
  "react-codemirror": "/react-codemirror/static-1.11003",
  "react-colorpicker": "/react-colorpicker/static-2.10575",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8463",
  "rich-text-lib": "/rich-text-lib/static-1.20389",
  "tinymce-data": "/tinymce-data/static-1.41288",
  "tinymce-themes": "/tinymce-themes/static-1.57173",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10231",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5563",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16671",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.65",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10710",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10708",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5359",
  "base-ui": "/base-ui/static-1.23",
  "react-day-picker": "/react-day-picker/static-1.11",
  "trellis-theming": "/trellis-theming/static-1.1334",
  "tanstack-virtual": "/tanstack-virtual/static-1.39",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.435",
  "chirp-fetch": "/chirp-fetch/static-1.2257",
  "stylex-utils": "/stylex-utils/static-1.149",
  "chatspot-core": "/chatspot-core/static-1.23290",
  "copilot-toolkit": "/copilot-toolkit/static-1.11942",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13391",
  "data-fetching-client": "/data-fetching-client/static-1.10010",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5120",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9052",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29408",
  "usage-tracker": "/usage-tracker/static-1.7673",
  "cms-field-types": "/cms-field-types/static-1.5171",
  "content-icons-ui": "/content-icons-ui/static-1.2410",
  "integrations-lib": "/integrations-lib/static-1.17180",
  "customer-data-objects": "/customer-data-objects/static-1.8048",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1880",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5007",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.95",
  "graphql": "/graphql/static-1.90",
  "immer": "/immer/static-1.102",
  "immerable": "/immerable/static-1.4505",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9438",
  "video-components-external": "/video-components-external/static-1.12242",
  "video-data-lib": "/video-data-lib/static-1.35900",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.533",
  "audio-components": "/audio-components/static-1.6421",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29889",
  "FileManagerImages": "/FileManagerImages/static-1.37766",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1599",
  "html-to-image": "/html-to-image/static-1.62",
  "redux-toolkit": "/redux-toolkit/static-1.79",
  "salesImages": "/salesImages/static-1.622",
  "ui-universal-auth": "/ui-universal-auth/static-1.9502",
  "urlinator": "/urlinator/static-1.4877",
  "video-components": "/video-components/static-1.14244",
  "video-embed": "/video-embed/static-1.36734",
  "ts-schema": "/ts-schema/static-1.4330",
  "ContentData": "/ContentData/static-1.69309",
  "layout-data-lib": "/layout-data-lib/static-1.10348",
  "react-dnd-compat": "/react-dnd-compat/static-1.4975",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1905",
  "external-options-client-types": "/external-options-client-types/static-1.4377",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7254",
  "hs-promise-utils": "/hs-promise-utils/static-1.5950",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4083",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9295",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3425",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.184",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11508",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5799",
  "magpie-types": "/magpie-types/static-1.5259",
  "simple-logging-lib": "/simple-logging-lib/static-1.3410",
  "avatar-components": "/avatar-components/static-1.2844",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10191",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6946",
  "flux-actions": "/flux-actions/static-1.375",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5235",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14595",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5971",
  "laboratory-lib": "/laboratory-lib/static-3.7513",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8126",
  "redux-observable": "/redux-observable/static-1.76",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10632",
  "unified-auth": "/unified-auth/static-1.1016",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.858",
  "breeze-engine-core": "/breeze-engine-core/static-1.1158",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.87",
  "pulse": "/pulse/static-1.991",
  "navigation-messaging": "/navigation-messaging/static-1.8259",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13358",
  "content-media-compositions": "/content-media-compositions/static-2.17365",
  "idb-keyval": "/idb-keyval/static-1.52",
  "media-bridge-lib": "/media-bridge-lib/static-1.19481",
  "nudge-client-utils": "/nudge-client-utils/static-1.3229",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1298",
  "social-insights-client-types": "/social-insights-client-types/static-1.22728",
  "advanced-menus-core": "/advanced-menus-core/static-1.15650",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12507",
  "ExportDialog": "/ExportDialog/static-6.10740",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34941",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4053",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4384",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.373",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4258",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7159",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3944",
  "persist-promise": "/persist-promise/static-1.4062",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6057",
  "reactive-lib": "/reactive-lib/static-1.1079",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.694",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3369",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.568",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1567",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.66",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1130",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.266",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.606",
  "slack-ui-library": "/slack-ui-library/static-1.10758",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.494",
  "event-emitter": "/event-emitter/static-1.1318",
  "fast-json-patch": "/fast-json-patch/static-1.71",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2986",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3305",
  "onboarding-tours": "/onboarding-tours/static-1.17215",
  "whisper-core-api": "/whisper-core-api/static-1.7427",
  "fsm": "/fsm/static-1.4114",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15649",
  "simple-menus-lib": "/simple-menus-lib/static-1.17166",
  "settings-ui-lib": "/settings-ui-lib/static-1.12883",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3803",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10211",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19350",
  "growth-data-modal": "/growth-data-modal/static-1.5971",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2788",
  "navigation-components": "/navigation-components/static-1.18932",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5430",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1282",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8013",
  "user-context": "/user-context/static-1.5471",
  "react-flip-move": "/react-flip-move/static-1.79",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2613",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2816",
  "user-context-client": "/user-context-client/static-1.4869",
  "nest": "/nest/static-1.596",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18468",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15653",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7971",
  "onboarding-scopes": "/onboarding-scopes/static-1.6813"
}
};
